import { Badge, Box, Popover, Stack, Typography } from '@mui/material';
import { useState } from 'react';

import { FSPrimaryButton } from '@/ui/components/button/FSPrimaryButton';
import { translate } from '@/ui/i18n';
import { ColorsRaw } from '@/ui/theme/colors-raw';

export function AssignButton({
  invitationCount,
  onClickOpen,
  enableExternalPublic = false,
}: {
  invitationCount: number;
  onClickOpen: (mode: 'normal' | 'public') => void;
  enableExternalPublic?: boolean;
}) {
  if (enableExternalPublic) {
    return (
      <AssignButtonPublic
        invitationPublicSupplierCount={invitationCount}
        onClickPublic={() => {
          onClickOpen('public');
        }}
        onClickPublicSupplier={() => {
          onClickOpen('normal');
        }}
      />
    );
  }
  return (
    <AssignButtonBasic
      invitationCount={invitationCount}
      onClickOpen={() => onClickOpen('normal')}
    />
  );
}

function AssignButtonBasic({
  invitationCount,
  onClickOpen,
}: {
  invitationCount: number;
  onClickOpen: () => void;
}) {
  return (
    <>
      <Badge color="secondary" badgeContent={invitationCount}>
        <FSPrimaryButton color="info" onClick={onClickOpen}>
          {translate('Quiz.assign')}
        </FSPrimaryButton>
      </Badge>
    </>
  );
}

function AssignButtonPublic({
  invitationPublicSupplierCount,
  onClickPublic,
  onClickPublicSupplier,
}: {
  invitationPublicSupplierCount: number;
  onClickPublic: () => void;
  onClickPublicSupplier: () => void;
}) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const onClickAssignButton = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const onClosePopover = () => {
    setAnchorEl(null);
  };
  return (
    <>
      <Badge color="secondary" badgeContent={invitationPublicSupplierCount}>
        <FSPrimaryButton color="info" onClick={onClickAssignButton}>
          {translate('Quiz.assign')}
        </FSPrimaryButton>
      </Badge>
      <Popover
        anchorEl={anchorEl}
        open={open}
        onClose={onClosePopover}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        sx={{ mt: 1 }}
      >
        <Box sx={{ maxWidth: 400, p: 2 }}>
          <Stack spacing={1}>
            <Typography>{translate('Quiz.assign-public.question')}</Typography>
            <Stack direction={'row'} spacing={1} justifyContent={'center'}>
              <Badge
                color="secondary"
                badgeContent={invitationPublicSupplierCount}
              >
                <FSPrimaryButton
                  sx={{
                    backgroundColor: ColorsRaw.anthracite.Warm_Anthracite_2,
                  }}
                  color="info"
                  onClick={() => {
                    onClosePopover();
                    onClickPublicSupplier();
                  }}
                >
                  {translate('Quiz.assign-public.button-supplier')}
                </FSPrimaryButton>
              </Badge>
              <FSPrimaryButton
                sx={{ backgroundColor: ColorsRaw.anthracite.Warm_Anthracite_2 }}
                color="info"
                onClick={() => {
                  onClosePopover();
                  onClickPublic();
                }}
              >
                {translate('Quiz.assign-public.button-public')}
              </FSPrimaryButton>
            </Stack>
          </Stack>
        </Box>
      </Popover>
    </>
  );
}
